module.exports = __webpack_public_path__ + "static/media/phone-frame-2.b42c1ced.png";